import { render } from "./WorkSection.vue?vue&type=template&id=ea00f72c&scoped=true"
import script from "./WorkSection.vue?vue&type=script&lang=js"
export * from "./WorkSection.vue?vue&type=script&lang=js"

import "./WorkSection.vue?vue&type=style&index=0&id=ea00f72c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea00f72c"]])

export default __exports__